export enum EOrderStatus {
    ON_HOLD = 'on_hold',
    PENDING = 'pending',
    PREPARING = 'preparing',
    IN_DELIVERY = 'in_delivery',
    PARTIALLY_DELIVERED = 'partially_delivered',
    DELIVERED = 'delivered',
    PARTIALLY_RETURNED = 'partially_returned',
    RETURNED = 'returned',
    CANCELLED = 'cancelled',
}
